import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Heading from "../../../components/heading";
import "./admin.css";

const Admin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("users");

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    if (path) {
      setActiveKey(path);
    }
  }, [location]);

  const handleMenuClick = (e: { key: string }) => {
    setActiveKey(e.key);
    navigate(`/admin/${e.key}`);
  };

  return (
    <div>
      <Heading title="Admin" />
      <Menu
        mode="horizontal"
        selectedKeys={[activeKey]}
        onClick={handleMenuClick}
      >
        <Menu.Item key="users">Users</Menu.Item>
        <Menu.Item key="transfer-ids">Transfer IDs</Menu.Item>
      </Menu>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default Admin;
